import React from 'react';
import { Col, Row } from 'react-grid-system';
import slugify from 'slugify';
import PropTypes from 'prop-types';

import { getObjectProperty, windowExists } from '../../utils/index';
import { MediaCard, ContentCard, ProfileCard } from '../Card';

function handleCard(component) {
  let Card = ContentCard;

  if (!windowExists) {
    return null;
  }

  if (typeof component.cardType !== 'undefined') {
    Card = require('../Card')[`${component.cardType}Card`];
  }

  return (
    <Card {...component} key={component.id} />
  );
}

function handleCompany(component) {
  return (
    <MediaCard
      {...component}
      key={component.id}
      link={component.status === 'current' ? `company/${component.slug}` : null}
      title={null}
    />
  );
}

function handleSpeaker(component) {
  let slug, url;

  if (component.role && component.role.includes('Speaker')) {
    url = null;
  } else {
    slug = slugify(`${component.firstName} ${component.lastName}`, { lower: true });
    url = `people/${slug}`;
  }

  return (
    <ProfileCard
      {...component}
      name={`${component.firstName} ${component.lastName}`}
      image={component.imageSrc}
      link={url}
      key={component.id}
    />
  );
}

function Cards(props) {
  const { components } = props;

  const sections = {
    ContentfulCard: handleCard,
    ContentfulCompany: handleCompany,
    ContentfulSpeaker: handleSpeaker,
  };

  const gridSize = components.length === 1 ? 12 : 6;

  return (
    <Row justify="center">
      {components && components.map((component) => {
        const sectionHandler = getObjectProperty(sections, component.__typename, null);

        return (
          <Col xs={12} md={gridSize} key={component.id}>
            {sectionHandler(component)}
          </Col>
        );
      })}
    </Row>
  );
}

export default Cards;

Cards.propTypes = {
  components: PropTypes.arrayOf(PropTypes.object),
};

Cards.defaultProps = {
  components: null,
};
